'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var createInitialState = function createInitialState(props) {
  return _extends({
    latitude: null,
    longitude: null,
    error: null
  }, props);
};

// https://developer.mozilla.org/en-US/docs/Web/API/PositionError
var errors = {
  1: 'PERMISSION_DENIED',
  2: 'POSITION_UNAVAILABLE',
  3: 'TIMEOUT'
};
var types = {
  SAVE_GEOLOCATION: 'SAVE_GEOLOCATION',
  GEOLOCATION_ERROR: 'GEOLOCATION_ERROR'
};
var find = function find(val) {
  return function (payload) {
    var found = payload.find(function (x) {
      return x.types.includes(val);
    });
    if (found) return found.short_name;
  };
};
var decodeResponse = function decodeResponse(json) {
  var options = {
    streetNumber: {
      findVal: find('street_number')
    },
    address: {
      findVal: find('route')
    },
    city: {
      findVal: find('locality')
    },
    state: {
      findVal: find('administrative_area_level_1')
    },
    country: {
      findVal: find('country')
    },
    zip: {
      findVal: find('postal_code')
    }
  };
  var payload = json.results[0].address_components;
  return Object.keys(options).reduce(function (acc, x) {
    var result = options[x].findVal(payload);
    return result ? _extends({}, acc, _defineProperty({}, x, result)) : _extends({}, acc);
  }, {});
};
var fetchLocationDetails = function fetchLocationDetails(latitude, longitude, apiKey) {
  return fetch('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + latitude + ',' + longitude + '&key=' + apiKey).then(function (result) {
    return result.json();
  }).then(function (json) {
    return decodeResponse(json);
  }).catch(function (err) {
    console.log('error fetching location details', err);
  });
};
var actions = {
  saveGeolocation: function saveGeolocation(payload, googleAPIKey) {
    return function (dispatch) {
      // When there is no API key we don't want to get the location details
      if (!googleAPIKey) {
        return dispatch({
          type: types.SAVE_GEOLOCATION,
          payload: payload
        });
      }

      // When there is an API key get details from google maps
      fetchLocationDetails(payload.latitude, payload.longitude, googleAPIKey).then(function (locationDetails) {
        return dispatch({
          type: types.SAVE_GEOLOCATION,
          payload: _extends({}, payload, locationDetails)
        });
      });
    };
  },
  geolocationError: function geolocationError(error) {
    return {
      type: types.GEOLOCATION_ERROR,
      payload: error
    };
  }
};
var selector = function selector(state) {
  return state.geolocation;
};
var initialState = createInitialState();
var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case types.SAVE_GEOLOCATION:
      {
        return _extends({}, state, payload);
      }
    case types.GEOLOCATION_ERROR:
      {
        return _extends({}, state, {
          error: {
            code: payload.code,
            message: payload.message,
            type: errors[payload.code] || 'UNKNOWN_ERROR'
          }
        });
      }
    default:
      {
        return state;
      }
  }
};
exports.types = types;
exports.actions = actions;
exports.selector = selector;
exports.createInitialState = createInitialState;
exports.default = reducer;